import { z } from "zod/v4";

export const newsStatusSchema = z.enum(["draft", "published"]);

export const newsItemSchema = z.object({
	id: z.string().uuid(),
	title: z.string(),
	teaser: z.string().nullable().optional(),
	image_url: z.string().nullable().optional(),
	source_url: z.string(),
	source_name: z.string().nullable().optional(),
	status: newsStatusSchema,
	published_at: z.string().nullable().optional(),
	created_at: z.string(),
	updated_at: z.string(),
});

export const createNewsItemSchema = z.object({
	title: z.string().min(1, "Title is required"),
	teaser: z.string().optional(),
	image_url: z.union([z.string().url("Must be a valid URL"), z.literal("")]).optional(),
	source_url: z.string().url("Must be a valid URL"),
	source_name: z.string().optional(),
});

export const updateNewsItemSchema = createNewsItemSchema;

export type NewsStatus = z.infer<typeof newsStatusSchema>;
export type NewsItem = z.infer<typeof newsItemSchema>;
export type CreateNewsItem = z.infer<typeof createNewsItemSchema>;
export type UpdateNewsItem = z.infer<typeof updateNewsItemSchema>;
